import lightbox from 'lightbox2';
function lightboxGallery() {
  lightbox.option({
    'resizeDuration': 200,
    'wrapAround': true
  });
}
export default function sliders() {
  lightboxGallery();
}